import { Link, router } from '@inertiajs/react'
import { AdminShell } from '@/components/layout/AdminShell'
import { PageHeader } from '@/components/landing/PageHeader'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

interface AdminOrg {
  id: string
  name: string
  slug: string
  plan: string
  suspended: boolean
  suspended_at: string | null
  user_count: number
  app_count: number
  created_at: string
}

interface Props {
  admin: { email: string }
  organizations: AdminOrg[]
}

export default function Index({ admin, organizations }: Props) {
  function suspend(id: string) {
    router.post(`/admin/organizations/${id}/suspend`)
  }

  function unsuspend(id: string) {
    router.post(`/admin/organizations/${id}/unsuspend`)
  }

  return (
    <AdminShell admin={admin}>
      <div className="space-y-8">
        <PageHeader
          eyebrow="Admin"
          title="Organizations"
          description={`${organizations.length} organization${organizations.length !== 1 ? 's' : ''} total.`}
        />

        <div className="surface-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Plan</TableHead>
                <TableHead>Users</TableHead>
                <TableHead>Apps</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Created</TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {organizations.map((org) => (
                <TableRow key={org.id}>
                  <TableCell className="font-medium">{org.name}</TableCell>
                  <TableCell className="text-muted-foreground capitalize">{org.plan}</TableCell>
                  <TableCell>{org.user_count}</TableCell>
                  <TableCell>{org.app_count}</TableCell>
                  <TableCell>
                    <Badge variant={org.suspended ? 'destructive' : 'default'}>
                      {org.suspended ? 'suspended' : 'active'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground text-sm">
                    {new Date(org.created_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2 justify-end">
                      {org.suspended ? (
                        <Button size="sm" variant="outline" onClick={() => unsuspend(org.id)}>
                          Unsuspend
                        </Button>
                      ) : (
                        <Button size="sm" variant="outline" onClick={() => suspend(org.id)}>
                          Suspend
                        </Button>
                      )}
                      <Button size="sm" variant="ghost" asChild>
                        <Link href={`/admin/organizations/${org.id}`}>View</Link>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </AdminShell>
  )
}
